module.exports = __webpack_public_path__ + "img/twitter-icon.0a968929.svg";